import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import moment from "moment";
import {
  deleteFileAction,
  SubmitApprovalRequestAction,
  uploadFileAction,
  ViewRequestStatusAction,
} from "../../../redux/actions/GlobalAction";
import {
  addAccrediationRowAction,
  getProfileVerificationAction,
  saveProfileVerificationAction,
} from "../../../redux/actions/ProfileVerificationAction";
import {
  AllowedFile,
  AllowedFileText,
  getSnackbarSuccess,
  MandatoryStar,
  ShowImageComponent,
} from "../../../Utils/helper";
import { saveData, uploadDateHandler } from "./helper";
import UploadDocuments from "./UploadDocuments";
import { DeleteRowPopup } from "./DeleteRowPopup";
import {
  EditSaveHandler,
  isPageEditFalse,
} from "../CommonComponent/EditSaveHandler";
import {
  deletePermanentImageHandler,
  deleteStagingImageHandler,
} from "../CommonComponent/commonfunctionality";
import ROUTES from "../../../Utils/routesConstants";
import { getCampaignsToken, getNetworkMenuId, getProviderPortalId, getRole } from "../../../Utils/types";
import { addProviderAssitLogAction } from "../../../redux/actions/ProviderAssistAction";
import { useLocation, useParams } from "react-router-dom";

const ProfileVerification = () => {
  const dispatch = useDispatch();
  const urlParams = useParams();
  const location = useLocation()
  let source = location?.search.split("=")[1]
  localStorage.setItem("campaignsToken", urlParams?.token);
  const [isTableShow, setIsTableShow] = useState(true);
  const [profileVerification, setProfileVerification] = useState(null);
  const [spinner, setSpinner] = useState(true);
  const [deleteRowData, setDeleteRowData] = useState(null);
  const getProfileVerification = useSelector(
    (state) =>
      state?.profileVerificationReducer?.getProfileVerification
        ?.profileVerification
  );
  const isShowSubmitButton = useSelector(
    (state) =>
      state?.profileVerificationReducer?.getProfileVerification
        ?.isShowSubmitButton
  );
  const isPageEdit = useSelector((state) => state?.globalReducer?.isPageEdit);

  useEffect(() => {
    dispatch(getProfileVerificationAction());
  }, []);

  useEffect(() => {
    if (getProfileVerification) {
      setProfileVerification({
        ...getProfileVerification,
        ispecifyList: getProfileVerification?.accreditationList?.map((ele) => {
          return {
            value: ele?.accreditationName,
            label: ele?.accreditationName,
          };
        }),
      });
      setTimeout(() => setSpinner(false), 300);
    }
    if (getProfileVerification?.accreditationList === null) {
      setIsTableShow(false);
      setProfileVerification({
        ...getProfileVerification,
        ispecifyList: [],
      });
    }
  }, [getProfileVerification]);

  const HandleTableShow = (e) => {
    if (
      e.target.value === "false" &&
      !getProfileVerification?.accreditationList?.length !== 0 &&
      getProfileVerification?.accreditationList !== null
    ) {
      getSnackbarSuccess("info", "first delete all the rows", dispatch);
    } else {
      setIsTableShow(
        e.target.value === "true" ? true : e.target.value === "false" && false
      );
    }
  };
  const HandleMultipleSelect = async (event) => {
    const temp = getProfileVerification?.accreditationList?.map(
      (ele) => ele.accreditationName
    );
    if (temp === undefined) {
      await dispatch(addAccrediationRowAction(event?.[0]));
    } else {
      const absent = event.filter((e) => !temp.includes(e));
      await dispatch(addAccrediationRowAction(absent?.[0]));
    }
  };

  const SaveHandler = async (event) => {
    event.preventDefault();
    await dispatch(saveProfileVerificationAction(source === "WhatsApp" || source === "Email" ? {...saveData,source:source}:getRole() === "NetworkAdmin" ? {...saveData,source:"Network"} :saveData));
    await dispatch(getProfileVerificationAction());
    await isPageEditFalse(dispatch);
    await dispatch(ViewRequestStatusAction("ProfileVerification"));
    window.location.pathname.includes(ROUTES.PROVIDER_ASSIST) &&
      (await dispatch(
        addProviderAssitLogAction({
          providerId: getProviderPortalId(),
          moduleName: "ProfileVerification",
          actionFlag: "E",
        })
      ));
  };

  return (
    <form onSubmit={SaveHandler}>
      <div className="right-section">
        <div className="card profile-verification-section">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center edit-save-css">
              <h4>Verification Details</h4>
              {((getNetworkMenuId()?.canEdit && getRole() === "NetworkAdmin") || getRole() === "ServiceProvider" ||  getCampaignsToken() !== undefined) &&
                <EditSaveHandler
                  isShowViewButton={isShowSubmitButton}
                  moduleName="ProfileVerification"
                />}
            </div>
            <div className="verification-card">
              <div className="row gx-5">
                <div className="col-md-6">
                  <h5 className="dropdown-heading">
                    Is your centre recognized by any association/ body ?
                  </h5>
                  <select
                    className="form-select mt-4"
                    style={{ maxWidth: "200px" }}
                    value={isTableShow}
                    onChange={(e) => {
                      HandleTableShow(e);
                    }}
                    disabled={!isPageEdit}
                  >
                    <option value={true}>Yes</option>
                    <option value={false}>No</option>
                  </select>
                </div>
                <div className="col-md-6">
                  {isTableShow && (
                    <h5 className="dropdown-heading dropdown-heading-specify">
                      Please Specify
                    </h5>
                  )}
                  {!spinner && isTableShow && (
                    <Select
                      placeholder="Select Client"
                      onChange={(event) =>
                        HandleMultipleSelect(event.map((e) => e.value))
                      }
                      isClearable={false}
                      components={{
                        DropdownIndicator: () => (
                          <img
                            style={{
                              width: "16px",
                              height: "16px",
                              marginRight: "10px",
                              cursor: isPageEdit && "pointer",
                            }}
                            src="./images/arrowdown.png"
                          />
                        ),
                        IndicatorSeparator: () => null,
                      }}
                      isMulti
                      closeMenuOnSelect={false}
                      name="colors"
                      options={getProfileVerification?.ispecifyList?.map(
                        (ele) => {
                          return {
                            value: ele?.code,
                            label: ele?.shortDesc,
                          };
                        }
                      )}
                      value={profileVerification?.ispecifyList}
                      isDisabled={!isPageEdit}
                    />
                  )}
                </div>
              </div>
              {isTableShow && (
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Accreditation Name</th>
                        <th>
                          Upload Accreditation Certificate <MandatoryStar />
                        </th>
                        <th>
                          Expiry Date <MandatoryStar />
                        </th>
                        {isPageEdit && <th>Remove</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {profileVerification?.accreditationList?.map(
                        (ele, index) => {
                          return (
                            <tr key={index}>
                              <th>{ele?.accreditationName}</th>
                              <td style={{ display: "flex",height:"43px" }}>
                                {ele?.accreditationCertificate === "" && (
                                  <div className="upload-file">
                                    <div className="upload-file__btn d-flex">
                                      <label>
                                        <input
                                          type="file"
                                          id="imageUpload"
                                          style={{ width: "2px" }}
                                          accept={AllowedFile}
                                          name={ele?.accreditationCertificate}
                                          onChange={async (e) => {
                                            const file = e.target.files[0];
                                            if (file.size > 2097152) {
                                              getSnackbarSuccess(
                                                "info",
                                                "Maximum upload file size is 2 MB.",
                                                dispatch
                                              );
                                            } else if (
                                              file.type !== "image/jpg" &&
                                              file.type !== "image/jpeg" &&
                                              file.type !== "image/png" &&
                                              file.type !== "application/pdf"
                                            ) {
                                              getSnackbarSuccess(
                                                "info",
                                                "File Types allowed are JPG, JPEG, PNG or PDF.",
                                                dispatch
                                              );
                                            } else {
                                              await dispatch(
                                                deleteFileAction(
                                                  ele?.providerImageStgId,
                                                  true
                                                )
                                              );
                                              await dispatch(
                                                uploadFileAction(
                                                  e.target.files[0],
                                                  ele?.accreditationName,
                                                  dispatch
                                                )
                                              );
                                              await dispatch(
                                                getProfileVerificationAction()
                                              );
                                            }
                                          }}
                                          disabled={!isPageEdit}
                                          required={
                                             ele?.isSpecialFlag === true ? false : true
                                          }
                                        />
                                        <span
                                          style={{
                                            cursor: !isPageEdit && "auto",
                                          }}
                                        >
                                          <img
                                            src="./images/uploadicon.svg"
                                            alt=""
                                          />
                                          UPLOAD
                                        </span>
                                      </label>
                                      <AllowedFileText topmargin="0px" />
                                    </div>
                                  </div>
                                )}
                                <div style={{ paddingLeft: "10px" }}>
                                  {ele?.accreditationCertificate !== null && (
                                    <ShowImageComponent
                                      imageUrl={ele?.accreditationCertificate}
                                      showMsg={
                                        ele?.accreditationName.toLowerCase() +
                                        "-accreditation-certificate"
                                      }
                                    />
                                  )}
                                  {isPageEdit &&
                                    ele?.accreditationCertificate !== "" && (
                                      <img
                                        src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png"
                                        type="button"
                                        onClick={async () => {
                                          {
                                            ele?.isVerified &&
                                              deletePermanentImageHandler(
                                                ele?.providerImageId,
                                                ele?.accreditationName,
                                                getProfileVerificationAction,
                                                dispatch
                                              );
                                          }
                                          {
                                            !ele?.isVerified &&
                                              deleteStagingImageHandler(
                                                ele?.providerImageStgId,
                                                false,
                                                getProfileVerificationAction,
                                                dispatch
                                              );
                                          }
                                        }}
                                        alt=""
                                      />
                                    )}
                                </div>
                              </td>
                              <td className="text-center">
                                <input
                                  type="date"
                                  onKeyDown={(e) => {
                                    e.preventDefault();
                                  }}
                                  className="form-control date-icon"
                                  style={{ border: "0", paddingBottom: "0" }}
                                  value={
                                    ele?.accreditationValidity ===
                                      "1900-01-01T00:00:00"
                                      ? null
                                      : moment(
                                        ele?.accreditationValidity
                                      ).format("YYYY-MM-DD")
                                  }
                                  onChange={async (e) => {
                                    await uploadDateHandler(
                                      ele?.accreditationName,
                                      e.target.value,
                                      dispatch,
                                      source
                                    );
                                    await dispatch(
                                      getProfileVerificationAction()
                                    );
                                  }}
                                  disabled={
                                    !isPageEdit || ele?.isVerified === true
                                  }
                                  required={ele?.isSpecialFlag === true ? false : true}
                                />
                              </td>
                              {isPageEdit && (
                                <td>
                                  {ele?.isSpecialFlag === true ? <></> : <img
                                    src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png"
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#staticBackdropDeleteRow"
                                    alt=""
                                    onClick={() => {
                                      setDeleteRowData(ele)
                                    }}
                                  /> }
                                </td>
                              )}
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <DeleteRowPopup
              deleteRowData={deleteRowData}
              setDeleteRowData={setDeleteRowData}
            />
            <UploadDocuments isPageEdit={isPageEdit} />
            <div className="mt-4 mb-2 text-end">
              {isShowSubmitButton && !isPageEdit && (
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={async () => {
                    await dispatch(
                      SubmitApprovalRequestAction("ProfileVerification")
                    );
                    await dispatch(getProfileVerificationAction());
                    await dispatch(
                      ViewRequestStatusAction("ProfileVerification")
                    );
                    window.location.pathname.includes(ROUTES.PROVIDER_ASSIST) &&
                      (await dispatch(
                        addProviderAssitLogAction({
                          providerId: getProviderPortalId(),
                          moduleName: "ProfileVerification",
                          actionFlag: "S",
                        })
                      ));
                  }}
                >
                  SUBMIT
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ProfileVerification;
